module.exports = __webpack_public_path__ + "img/progress.b9c7c939.png";